export function getSelectedTreatmentTemplates(treatment_plan_groups, value) {
  return treatment_plan_groups
    .flatMap(group => group.plans)
    .filter(plan => value[plan.id] === true)
}
